import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';
import classNames from 'classnames';

import './textarea.scss';

class TextValidator extends ValidatorComponent {
  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      validatorListener,
      title,
      formValid,
      icon: Icon,
      style = {},
      fullWidth = false,
      ...rest
    } = this.props;

    const error = this.errorText();
    const inputClass = classNames('custom-textarea', {
      error: error || !formValid,
      'full-width': fullWidth,
    });
    return (
      <div className="main-wrapper" style={style}>
        <div className={inputClass}>
          {title && <label>{title}</label>}
          <textarea {...rest} rows={9} />
          {Icon && (
            <div className="icon-wrapper">
              <Icon />
            </div>
          )}
        </div>
        {formValid && error}
      </div>
    );
  }

  errorText() {
    const { isValid } = this.state;

    if (isValid) {
      return null;
    }

    return <div style={{ color: 'red' }}>{this.getErrorMessage()}</div>;
  }
}

export default TextValidator;
